module.exports = __webpack_public_path__ + "dd0bea1f9a808d633492fa573039ca1d.svg";